const BellOff = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.22 7.84 4.515 5.137a.5.5 0 1 1 .707-.707l14.85 14.85a.5.5 0 0 1-.708.706l-1.716-1.716H5.5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.355a.49.49 0 0 1 .356-.144h1.115v-6.923q0-1.368.605-2.505m9.164 9.166v.263H7.615v-6.923q0-.954.35-1.759z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M16.385 10.346v2.21a.5.5 0 0 0 1 0v-2.21q0-1.959-1.24-3.447A5.27 5.27 0 0 0 13 5.046V4.5a.96.96 0 0 0-.293-.708.97.97 0 0 0-.71-.292.96.96 0 0 0-.706.292A.97.97 0 0 0 11 4.5v.546q-.585.112-1.106.33c-.312.13-.365.532-.126.77a.56.56 0 0 0 .603.112A4.4 4.4 0 0 1 12 5.962q1.823 0 3.104 1.28 1.28 1.281 1.28 3.104M11.997 20.885a1.55 1.55 0 0 1-1.14-.475 1.56 1.56 0 0 1-.473-1.14h3.232q-.001.67-.476 1.143a1.56 1.56 0 0 1-1.144.471"
    />
  </>
)
export default BellOff
